import { Cell } from './Cell'
import { CELL_COUNT } from '../../constants/WordLength'


export const EmptyRow = () => {
  const emptyCells = Array.from(Array(CELL_COUNT))

  return (
    <div className="flex justify-center mb-1">
      {emptyCells.map((_, i) => (
        <Cell key={i} />
      ))}
    </div>
  )
}
